import { render, staticRenderFns } from "./TaxYearSummary.vue?vue&type=template&id=7152d157&"
import script from "./TaxYearSummary.vue?vue&type=script&lang=ts&"
export * from "./TaxYearSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports